import React from 'react';
import './Main-Section.scss';
import Skeleton from 'react-loading-skeleton';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fetchHomepageSlider } from 'stores/Homepage/homepageActions';

import imgSpacer from 'assets/img/main-section-spacer.gif';
import Carousel from 'components/shared/Carousel';

function MainSection(props) {

  const { sliders, fetchHomepageSlider, slidsFetched } = props;

  React.useEffect(() => {
    if (!slidsFetched) {
      fetchHomepageSlider();
    }
  }, [slidsFetched, fetchHomepageSlider])

  let content = (
    <div className="main-section mainSectionLoader">
      <div className="table">
        <div className="table-cell">

          <div className="container">
            <div className="main-section-title-wrapper">
              <h1 className="title">
                <Skeleton count={2} />
              </h1>
            </div>
            <div className="main-section-desc-wrapper">
              <p className="desc">
                <Skeleton count={2} />
              </p>
            </div>
            <div style={{ maxWidth: '200px' }}>
              <Skeleton />
            </div>
          </div>


        </div>
      </div>

      <img src={imgSpacer} className="spacer" alt="" />
    </div>
  );

  if (slidsFetched && sliders.length === 0) {
    content = <div>Something wentWrong</div>
  }

  if (sliders.length) {
    let slides = sliders.map(item => {
      item.id = item.desktop_image
      return item
    });
    content = (
      <Carousel
        id="main_section_slider"
        large={1}
        mid={1}
        small={1}
        show_dots={false}
        direction={props.direction}
        type="SlideMainSection"
        initial_shift={0}
        show_next_prev_buttons={true}
        slides={slides}
        autoRotate={true}
        speed={5000}
      />
    );

  }

  return <div className="mainSectionBlock dark-bg">{content}</div>;
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    { fetchHomepageSlider },
    dispatch
  );
};

const mapStateToProps = state => {
  return {
    direction: state.layout.direction,
    sliders: state.homePage.sliders,
    sliderLoading: state.homePage.sliderLoading,
    slidsFetched: state.homePage.slidsFetched
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MainSection);